import { html, when } from '@microsoft/fast-element';
import type { SefAgreementRequired } from './sef-agreement-required';
export const SefAgreementRequiredTemplate = html<SefAgreementRequired>`
  ${when(
    (x) => false,
    html`
      <div class="sef-group">
        <span class="countNumber">${(x) => x.companies.length}</span>
        <label>View SEF Agreement</label>
      </div>
    `
  )}
`;
